/* Theme ArtWeb v1.0.0 · © Studio Art Web · https://studioartweb.com.br · não editar sem falar com o Studio */
/*
 * Harmony Health | hh-mascaras.js
 * Máscara de digitação para campos de formulário, sem biblioteca:
 *   <input data-hh-mascara="telefone|cnpj|cpf|cep">
 * - Aceita só números (o CNPJ também aceita letras nas 12 primeiras posições, regra
 *   do CNPJ alfanumérico da Receita) e formata enquanto a pessoa digita.
 * - Colar funciona com qualquer formato: "+55 11 91234-5678", "11912345678" etc.
 * - O cursor fica no lugar certo, inclusive ao apagar sobre um parêntese ou traço.
 * - Campo incompleto ou CNPJ/CPF com dígito errado avisa no envio (validação do
 *   navegador) e, ao sair do campo, mostra a mensagem logo abaixo, ligada ao campo
 *   por aria-describedby.
 * Eventos ficam no documento: serve também para campos inseridos depois (avise-me).
 * Carregar com <script type="module"> só nas seções que têm campo com máscara.
 */

const SO_DIGITOS = /\D/g;

/** Limpa o valor bruto conforme o tipo. */
function limpa(tipo, valor) {
  if (tipo === 'cnpj') {
    const c = String(valor).toUpperCase().replace(/[^0-9A-Z]/g, '');
    // 12 primeiros podem ter letra; os 2 últimos (dígitos verificadores) só número.
    let saida = '';
    for (const ch of c) {
      if (saida.length >= 14) break;
      if (saida.length >= 12 && !/\d/.test(ch)) continue;
      saida += ch;
    }
    return saida;
  }
  let d = String(valor).replace(SO_DIGITOS, '');
  if (tipo === 'telefone') {
    if (d.length > 11 && d.startsWith('55')) d = d.slice(2);
    if (d.length > 11 && d.startsWith('0')) d = d.slice(1);
    return d.slice(0, 11);
  }
  if (tipo === 'cpf') return d.slice(0, 11);
  if (tipo === 'cep') return d.slice(0, 8);
  return d;
}

/** Monta o texto formatado a partir dos caracteres limpos. */
function formata(tipo, c) {
  if (!c) return '';
  if (tipo === 'telefone') {
    if (c.length <= 2) return `(${c}`;
    const ddd = c.slice(0, 2);
    const resto = c.slice(2);
    if (resto.length <= 4) return `(${ddd}) ${resto}`;
    const corte = resto.length === 9 ? 5 : 4;
    return `(${ddd}) ${resto.slice(0, corte)}-${resto.slice(corte)}`;
  }
  if (tipo === 'cnpj') {
    // 00.000.000/0000-00
    let s = c.slice(0, 2);
    if (c.length > 2) s += `.${c.slice(2, 5)}`;
    if (c.length > 5) s += `.${c.slice(5, 8)}`;
    if (c.length > 8) s += `/${c.slice(8, 12)}`;
    if (c.length > 12) s += `-${c.slice(12, 14)}`;
    return s;
  }
  if (tipo === 'cpf') {
    // 000.000.000-00
    let s = c.slice(0, 3);
    if (c.length > 3) s += `.${c.slice(3, 6)}`;
    if (c.length > 6) s += `.${c.slice(6, 9)}`;
    if (c.length > 9) s += `-${c.slice(9, 11)}`;
    return s;
  }
  if (tipo === 'cep') {
    return c.length > 5 ? `${c.slice(0, 5)}-${c.slice(5, 8)}` : c;
  }
  return c;
}

/** Caractere que conta para a máscara (número, ou letra no CNPJ). */
function conta(tipo, ch) {
  return tipo === 'cnpj' ? /[0-9A-Za-z]/.test(ch) : /\d/.test(ch);
}

/** Dígito verificador no padrão módulo 11 (CNPJ numérico e alfanumérico, CPF). */
function dv(base, pesos) {
  let soma = 0;
  for (let i = 0; i < base.length; i++) soma += (base.charCodeAt(i) - 48) * pesos[i];
  const r = soma % 11;
  return r < 2 ? 0 : 11 - r;
}

const PESOS_CNPJ_1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const PESOS_CNPJ_2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

function cnpjValido(c) {
  if (c.length !== 14 || /^(\d)\1{13}$/.test(c)) return false;
  const d1 = dv(c.slice(0, 12), PESOS_CNPJ_1);
  const d2 = dv(c.slice(0, 12) + d1, PESOS_CNPJ_2);
  return c.endsWith(`${d1}${d2}`);
}

function cpfValido(c) {
  if (c.length !== 11 || /^(\d)\1{10}$/.test(c)) return false;
  const d1 = dv(c.slice(0, 9), [10, 9, 8, 7, 6, 5, 4, 3, 2]);
  const d2 = dv(c.slice(0, 9) + d1, [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]);
  return c.endsWith(`${d1}${d2}`);
}

const MENSAGENS = {
  telefone: 'Digite o número com DDD, por exemplo (11) 91234-5678.',
  cnpj: 'Confira o CNPJ: são 14 números, por exemplo 12.345.678/0001-90.',
  cpf: 'Confira o CPF: são 11 números, por exemplo 123.456.789-09.',
  cep: 'Digite os 8 números do CEP, por exemplo 01310-100.',
};

/** Mensagem de erro do campo, ou texto vazio quando está certo (ou vazio). */
function erroDe(tipo, c, campo) {
  if (!c) return '';
  let ok = true;
  if (tipo === 'telefone') ok = c.length === 10 || c.length === 11;
  else if (tipo === 'cnpj') ok = cnpjValido(c);
  else if (tipo === 'cpf') ok = cpfValido(c);
  else if (tipo === 'cep') ok = c.length === 8;
  return ok ? '' : campo.dataset.hhMascaraErro || MENSAGENS[tipo] || '';
}

/** Coloca o cursor logo depois do n-ésimo caractere que conta. */
function posicaoDepois(tipo, texto, n) {
  if (n <= 0) {
    // Antes do primeiro caractere útil (ex.: depois do "(" do telefone).
    let i = 0;
    while (i < texto.length && !conta(tipo, texto[i])) i++;
    return i;
  }
  let vistos = 0;
  for (let i = 0; i < texto.length; i++) {
    if (conta(tipo, texto[i])) {
      vistos++;
      if (vistos === n) return i + 1;
    }
  }
  return texto.length;
}

function contaAte(tipo, texto, fim) {
  let n = 0;
  for (let i = 0; i < fim && i < texto.length; i++) if (conta(tipo, texto[i])) n++;
  return n;
}

/** Aplica a máscara mantendo o cursor depois de "uteis" caracteres. */
function aplica(campo, bruto, uteis) {
  const tipo = campo.dataset.hhMascara;
  const c = limpa(tipo, bruto);
  const texto = formata(tipo, c);
  if (campo.value !== texto) campo.value = texto;
  if (uteis !== undefined && document.activeElement === campo) {
    const pos = posicaoDepois(tipo, texto, Math.min(uteis, c.length));
    try { campo.setSelectionRange(pos, pos); } catch (e) { /* tipo sem seleção */ }
  }
  valida(campo, c);
}

function valida(campo, c) {
  const tipo = campo.dataset.hhMascara;
  const msg = erroDe(tipo, c === undefined ? limpa(tipo, campo.value) : c, campo);
  campo.setCustomValidity(msg);
  // Some com o aviso assim que o campo fica certo.
  if (!msg) mostraErro(campo, '');
  else if (campo.getAttribute('aria-invalid') === 'true') mostraErro(campo, msg);
  return msg;
}

/** Mostra (ou tira) a mensagem abaixo do campo, ligada por aria-describedby. */
function mostraErro(campo, msg) {
  const id = `${campo.id || 'hh-campo'}-mascara-erro`;
  let el = document.getElementById(id);
  const ligados = (campo.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
  if (!msg) {
    if (el) el.hidden = true;
    campo.removeAttribute('aria-invalid');
    const resto = ligados.filter((x) => x !== id);
    if (resto.length) campo.setAttribute('aria-describedby', resto.join(' '));
    else campo.removeAttribute('aria-describedby');
    return;
  }
  if (!el) {
    el = document.createElement('p');
    el.id = id;
    el.className = 'hh-campo__erro';
    el.setAttribute('aria-live', 'polite');
    const ancora = campo.closest('.hh-campo__caixa') || campo;
    ancora.insertAdjacentElement('afterend', el);
  }
  el.textContent = msg;
  el.hidden = false;
  campo.setAttribute('aria-invalid', 'true');
  if (!ligados.includes(id)) campo.setAttribute('aria-describedby', [id, ...ligados].join(' '));
}

const alvo = (e) => (e.target instanceof HTMLInputElement && e.target.dataset.hhMascara ? e.target : null);

document.addEventListener('input', (e) => {
  const campo = alvo(e);
  if (!campo) return;
  const tipo = campo.dataset.hhMascara;
  const fim = campo.selectionEnd ?? campo.value.length;
  aplica(campo, campo.value, contaAte(tipo, campo.value, fim));
});

// Apagar em cima de "(", ")", espaço, ponto, barra ou traço apaga o número vizinho.
document.addEventListener('beforeinput', (e) => {
  const campo = alvo(e);
  if (!campo) return;
  const tipo = campo.dataset.hhMascara;
  const { selectionStart: ini, selectionEnd: fim, value } = campo;
  if (ini === null || ini !== fim) return;
  if (e.inputType === 'deleteContentBackward' && ini > 0 && !conta(tipo, value[ini - 1])) {
    let i = ini - 1;
    while (i >= 0 && !conta(tipo, value[i])) i--;
    if (i < 0) return;
    e.preventDefault();
    aplica(campo, value.slice(0, i) + value.slice(i + 1), contaAte(tipo, value, i));
  } else if (e.inputType === 'deleteContentForward' && ini < value.length && !conta(tipo, value[ini])) {
    let i = ini;
    while (i < value.length && !conta(tipo, value[i])) i++;
    if (i >= value.length) return;
    e.preventDefault();
    aplica(campo, value.slice(0, i) + value.slice(i + 1), contaAte(tipo, value, ini));
  }
});

// Colar: monta o valor completo antes do limite de tamanho cortar o texto colado.
document.addEventListener('paste', (e) => {
  const campo = alvo(e);
  if (!campo || !e.clipboardData) return;
  const tipo = campo.dataset.hhMascara;
  const colado = e.clipboardData.getData('text') || '';
  e.preventDefault();
  const ini = campo.selectionStart ?? campo.value.length;
  const fim = campo.selectionEnd ?? campo.value.length;
  const antes = campo.value.slice(0, ini);
  const novo = antes + colado + campo.value.slice(fim);
  // Telefone colado com +55: conta os números já sem o código do país.
  const uteis = limpa(tipo, antes + colado).length;
  aplica(campo, novo, uteis);
  campo.dispatchEvent(new Event('change', { bubbles: true }));
});

// Ao sair do campo, mostra o aviso se ficou incompleto.
document.addEventListener('focusout', (e) => {
  const campo = alvo(e);
  if (!campo) return;
  const msg = valida(campo);
  if (msg) mostraErro(campo, msg);
});

// No envio, campo com problema mostra o aviso ao lado (além do balão do navegador).
document.addEventListener('invalid', (e) => {
  const campo = alvo(e);
  if (!campo) return;
  const msg = valida(campo);
  if (msg) mostraErro(campo, msg);
}, true);

/** Formata valores que já vieram preenchidos (volta do servidor ou preenchimento automático). */
function prepara(raiz = document) {
  raiz.querySelectorAll('input[data-hh-mascara]').forEach((campo) => {
    if (campo.value) aplica(campo, campo.value);
    else valida(campo, '');
  });
}

prepara();
// Preenchimento automático do Chrome pode chegar sem evento "input".
window.addEventListener('load', () => prepara(), { once: true });
